// Premium Theme JavaScript

document.addEventListener('DOMContentLoaded', function() {
  
  // Sticky header shadow on scroll
  var header = document.getElementById('header');
  if (header) {
    window.addEventListener('scroll', function() {
      if (window.scrollY > 10) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    });
  }
  
  // Mobile menu toggle
  var menuToggle = document.querySelector('.header__menu-toggle');
  var mobileNav = document.getElementById('mobile-nav');
  
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function() {
      var isOpen = mobileNav.classList.toggle('active');
      menuToggle.setAttribute('aria-expanded', isOpen);
    });
  }
  
  // Sticky Add to Cart visibility (mobile)
  var stickyATC = document.getElementById('sticky-atc');
  var productForm = document.querySelector('.product-form');
  
  if (stickyATC && productForm && window.innerWidth < 769) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          stickyATC.classList.remove('visible');
        } else {
          stickyATC.classList.add('visible');
        }
      });
    }, { threshold: 0, rootMargin: '-100px 0px 0px 0px' });
    
    observer.observe(productForm);
  }
  
  // Sticky ATC button click
  var stickyATCBtn = document.getElementById('sticky-atc-btn');
  if (stickyATCBtn && productForm) {
    stickyATCBtn.addEventListener('click', function() {
      var submitBtn = productForm.querySelector('[type="submit"]');
      if (submitBtn) {
        submitBtn.click();
      }
    });
  }
  
  // Lazyload images
  var lazyImages = document.querySelectorAll('img[loading="lazy"]');
  lazyImages.forEach(function(img) {
    if (img.complete) {
      img.classList.add('loaded');
    } else {
      img.addEventListener('load', function() {
        img.classList.add('loaded');
      });
    }
  });
  
  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      var href = this.getAttribute('href');
      if (href.length > 1) {
        var target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  });
  
});